// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2qHQ3","productName":"Table_productName__7e6Xx"};